import React from "react";
import { motion } from "framer-motion";
import { stats, showreelImage } from "../data/mock";
import AnimatedCounter from "./ui/AnimatedCounter";

const Stats = () => {
  return (
    <section
      className="relative py-28 overflow-hidden"
      style={{ background: "#0a0908" }}
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage: `url(${showreelImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            opacity: 0.18,
            filter: "grayscale(0.5) contrast(1.1) brightness(0.5)"
          }}
        />
      <div className="absolute inset-0" style={{
          background: "linear-gradient(180deg, #0a0908 0%, rgba(10,9,8,0.65) 50%, #0a0908 100%)"
        }} />
      </div>

      <div className="container-xl relative z-10 px-6">
        {/* Section Header */}
        <div className="max-w-4xl mb-16">
          <div className="flex items-center gap-4 mb-6">
            <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--gold)]">07</span>
            <span className="w-16 h-px bg-[var(--rule)]" />
            <span className="font-impact text-[11px] tracking-[0.4em] text-[var(--cream-muted)] uppercase">Impact Metrics</span>
          </div>
          <h2 className="font-display text-4xl md:text-6xl text-[var(--cream)] leading-tight">
            Meraki in <span className="italic gold-text">Numbers</span>
          </h2>
          <p className="mt-4 text-[var(--cream-muted)] text-sm md:text-base max-w-xl leading-relaxed uppercase tracking-[0.1em] opacity-60">
            A decade of cinematic precision and digital engineering, condensed into data points of excellence.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              className="group relative p-6 md:p-10 rounded-xl bg-white/[0.03] border border-white/10 hover:border-[var(--gold)]/40 transition-all duration-700 overflow-hidden flex flex-col items-center text-center"
              style={{ backdropFilter: "blur(20px)" }}
            >
              {/* Subtle background glow on hover */}
              <div className="absolute -inset-px bg-gradient-to-br from-[var(--gold)]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
              
              <div className="relative z-10 w-full">
                <div className="flex items-baseline gap-1 justify-center">
                  <div className="text-[clamp(32px,8vw,64px)] font-impact leading-none text-[var(--cream)] group-hover:text-[var(--gold)] transition-colors duration-700">
                    <AnimatedCounter value={parseInt(s.value)} suffix={s.suffix} />
                  </div>
                </div>
                
                <div className="mt-4 flex flex-col items-center gap-3">
                  <div className="w-8 h-px bg-[var(--gold)]/30 group-hover:w-16 group-hover:bg-[var(--gold)] transition-all duration-700" />
                  <div className="font-impact text-[9px] md:text-[10px] tracking-[0.3em] text-[var(--cream-muted)] group-hover:text-[var(--cream)] transition-colors duration-700 uppercase leading-relaxed max-w-[120px]">
                    {s.label}
                  </div>
                </div>
              </div>

              {/* Minimal corner accent */}
              <div className="absolute top-0 right-0 w-8 h-8 opacity-0 group-hover:opacity-100 transition-all duration-700 p-2">
                <div className="w-full h-full border-t border-r border-[var(--gold)]/40 rounded-tr-lg" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
